import "react";

import { Box, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

const calendarPrefix = "DRYPContainer";
export const calendarClasses = {
  root: `${calendarPrefix}-root`,
};

export const DRYPContainer = styled(Stack)(({ theme }) => ({
  [`&.${calendarClasses.root}`]: {
    flexDirection: "row",
    rowGap: theme.spacing(3),
    columnGap: theme.spacing(4),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    maxHeight: "210px",
    overflow: "auto",
    justifyContent: "center",
  },
}));

const yearItemPrefix = "DRYPYearItemContainer";
export const yearItemClasses = {
  root: `${yearItemPrefix}-root`,
  button: `${yearItemPrefix}-button`,
  divStartSelected: `${yearItemPrefix}-divStartSelected`,
  divEndSelected: `${yearItemPrefix}-divEndSelected`,
  selected: `${yearItemPrefix}-selected`,
  between: `${yearItemPrefix}-between`,
};

export const DRYPYearItemContainer = styled(Box)(({ theme }) => ({
  [`&.${yearItemClasses.root}`]: {
    height: "48px",
    width: "64px",
    maxWidth: "64px",
    [`&.${yearItemClasses.between}`]: {
      backgroundColor: theme.palette.border.main,
      borderRadius: "0px",
    },
    [`&.${yearItemClasses.divStartSelected}`]: {
      backgroundColor: theme.palette.border.main,
      borderTopLeftRadius: "64px",
      borderBottomLeftRadius: "64px",
    },
    [`&.${yearItemClasses.divEndSelected}`]: {
      backgroundColor: theme.palette.border.main,
      borderTopRightRadius: "64px",
      borderBottomRightRadius: "64px",
    },
    [`& .${yearItemClasses.button}`]: {
      ...theme.typography.subtitle1,
      height: "48px",
      width: "64px",
      maxWidth: "64px",
      backgroundColor: "transparent",
      border: "unset",
      borderRadius: "64px",
      boxSizing: "border-box",
      padding: theme.spacing(1),
      textTransform: "capitalize",
      color: theme.palette.black.dark,
      transition: "unset",
      "&:hover": {
        cursor: "pointer",
        border: `1px solid ${theme.palette.primary.main}`,
      },
      [`&.${yearItemClasses.selected}`]: {
        backgroundColor: theme.palette.primary.main,
        color: "white",
      },
    },
  },
}));
